import actions from '@lib/analytics/emarsys/actions'
import { AncillariesFormData } from '@lib/ancillary'
import seatSelectionUtils from '@lib/seatSelection'
import { Seats } from '@pages/Checkout/hooks/useInitialFormValues'

const { tagEvent, setEmailEvent, cartEvent } = actions

const getEmarsysSeats = (seats: Seat.BySegment) => {
  return seatSelectionUtils
    .flatten(seats)
    .map(seat => seat.code)
    .join(', ')
}

const getEmarsysAncillaries = (ancillaries: AncillariesFormData) => {
  return Object.entries(ancillaries)
    .filter(([_, value]) => value.length > 0)
    .map(([key]) => key)
    .join(', ')
}

const setEmail = (email: string) => {
  setEmailEvent(email)
}

const sendSeats = (seats: Seats) => {
  const outboundSeats = getEmarsysSeats(seats?.outbound)

  if (seats?.outbound && outboundSeats) {
    tagEvent(`select-outbound-seats`, { seats: outboundSeats })
  }

  const inboundSeats = getEmarsysSeats(seats?.inbound)

  if (seats?.inbound && inboundSeats) {
    tagEvent(`select-inbound-seats`, { seats: inboundSeats })
  }
}

const sendAncillaries = (ancillaries: AncillariesFormData) => {
  const items = getEmarsysAncillaries(ancillaries)

  if (items?.length) {
    tagEvent('select-ancillaries', { ancillaries: items })
  }
}

const sendCart = (items: CartItem[]) => {
  if (items?.length) {
    cartEvent(items)
  }
}

export default {
  setEmail,
  sendSeats,
  sendAncillaries,
  sendCart,
}
